export const apiFailureBus = new EventTarget();

export function emitApiFailure(error: Error | string) {
  apiFailureBus.dispatchEvent(new CustomEvent('onApiFailure', { detail: error }));
}
